import React from 'react';

export default function FullscreenIcon({ width = 24, height = 24, fill = '#171C33' }) {
  return (
    <svg
      data-id="fullscreen-icon"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M3 9V3H9V5H5V9H3ZM15 3H21V9H19V5H15V3ZM5 15V19H9V21H3V15H5ZM19 15H21V21H15V19H19V15Z"
        fill={fill}
      />
    </svg>
  );
}
